import { render, staticRenderFns } from "./privateBuy.vue?vue&type=template&id=ae1eb0de"
import script from "./privateBuy.vue?vue&type=script&lang=js"
export * from "./privateBuy.vue?vue&type=script&lang=js"
import style0 from "./privateBuy.vue?vue&type=style&index=0&id=ae1eb0de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports